export default [
    {
        path: '/agent',
        name: 'agent',
        component: () => import('../views/ai/AgentView.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/admin/models',
        name: 'admin-models',
        component: () => import('../views/ai/ModelsView.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/admin/models/token/:tokenId',
        name: 'admin-models-token',
        component: () => import('../views/ai/TokenView.vue'),
        meta: {
            requiresAuth: true
        },
    }
]
